import useAuth from '@/hooks/useAuth';
import useAxiosWLS from '../hooks/useAxiosWLS';
import * as config  from "../config";
import axios, { Axios, AxiosResponse } from 'axios';

export const useAnswers = <TResponse = any, TBody = any, TError = any>() => {
  const {user} = useAuth()
  
  const token = user?.token

  let url: string | undefined = undefined;
  const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`,
  }

  if(token){
      url = `${config.apiConfig.host}/answers`
  }


  const { data, error, loading, refetch, isReady } = useAxiosWLS<TResponse, TBody, TError>({ url, options: { headers } });

  return { data, error, loading, refetch, isReady };
};

export const useSaveAnswers = () => {
  const {user} = useAuth()
  
  const token = user?.token

  let url: string | undefined = undefined;
  const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": `Bearer ${token}`,
  }

  if(token){
      url = `${config.apiConfig.host}/answers`
  }

  return (params: any): Promise<AxiosResponse<any, any>>=>{
    if(url){
      return axios.put(url, params, {
          headers 
      })
    }
    return Promise.reject('No URL or token available')
  }
};